module.exports = __webpack_public_path__ + "img/old_logo.7373120.svg";